import { ALLOCATIONS, EXPERIMENTS } from '@fiverr-private/listing_experiments';

export const shouldReplacePaToggleWithOnline = (isBusiness: boolean, abTests: Record<string, number>) =>
    !isBusiness && Number(abTests[EXPERIMENTS.PANTHERS_REMOVE_PA_FILTER_TEST]) === Number(ALLOCATIONS.TEST_B);

export const shouldRemovePaToggle = (isBusiness: boolean, abTests: Record<string, number>) =>
    !isBusiness && Number(abTests[EXPERIMENTS.PANTHERS_REMOVE_PA_FILTER_TEST]) === Number(ALLOCATIONS.TEST_C);
